import { Box } from '@mui/material';

const MyIMOTabPanel = ({ children, value, index, ...other }) => {
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`myIMO-tabpanel-${index}`}
      aria-labelledby={`myIMO-tabpanel-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </Box>
  );
};

export default MyIMOTabPanel;
